<template>
  <div :class="_['order-box']">
    <img
      v-track="{
        name: '订单详情',
        id: 'cl9qeqzc1000qkcugasagete6',
      }"
      :class="_['order-img']"
      :src="orderInfo.pic"
      alt=""
      @click="toOrderDetail"
    />
    <div :class="_['order-info']">
      <div>
        <div
          v-track="{
            name: '订单详情',
            id: 'cl9qeqzc1000qkcugasagete6',
          }"
          :class="[_['order-name'], _._ellipsis2]"
          @click="toOrderDetail"
        >
          {{ orderInfo.commodityNames[0] }}
        </div>
        <div :class="_['order-num']">
          共{{ orderInfo.commodityNames.length }}件商品
        </div>
      </div>
      <div :class="_['order-space']">
        <div :class="_['space']">
          <span :class="_['space-icon']">￥</span>{{ orderInfo.orderAmount }}
        </div>
        <div>
          <van-button
            v-track="{
              name: '拒绝接单',
              id: 'cl9qeqdj9000okcug8m8idcop',
            }"
            :class="_['btn-style']"
            round
            type="default"
            @click="refuseShow = !refuseShow"
            >拒绝接单</van-button
          >
          <van-button
            v-track="{
              name: '立即接单',
              id: 'cl9qeps1w000mkcug7brxd65q',
            }"
            :class="[_['btn-style'], _['take-orderbtn']]"
            round
            color="linear-gradient(to right, #ff6034, #ee0a24)"
            @click="agreeTakeOrder(orderInfo.orderNo)"
            >接单</van-button
          >
        </div>
      </div>
    </div>
    <refuseSheet
      :show="refuseShow"
      @close="close"
      @confirmReason="confirmReason"
    />
  </div>
</template>

<script>
  import orderSetIcon from './images/店铺基础设置.png'
  import refuseSheet from './components/refuseSheet.vue'

  import Vue from 'vue'
  import { apiOrderMerchantOrderReject, apiOrderMerchantOrderTake } from '@/api'
  import { newRouteOnValueChange } from '@/utils'
  import { Toast } from 'vant'

  export default Vue.extend({
    components: { refuseSheet },
    props: {
      orderInfo: {
        type: Object,
        default: () => {
          return {}
        },
      },
    },
    data() {
      return {
        orderSetIcon: orderSetIcon,
        refuseShow: false,
      }
    },
    computed: {
      loading() {
        return false
      },
    },
    mounted() {
      newRouteOnValueChange({
        ctx: this,
        valueName: 'refuseShow',
        callback: v => {
          if (!v) {
            this.refuseShow = false
          }
        },
      })
    },
    methods: {
      close() {
        this.refuseShow = false
      },
      //同意接单
      async agreeTakeOrder(No) {
        await apiOrderMerchantOrderTake({ orderNo: No }, { hasStoreCode: true })
        Toast.success('接单成功')
        this.$emit('operation')
      },
      //拒绝接单
      async rejectTakeOrder(No, reason) {
        await apiOrderMerchantOrderReject(
          { orderNo: No, reason: reason },
          { hasStoreCode: true },
        )
        Toast.success('拒单成功')
        this.$emit('operation')
      },
      //拒绝弹框回调
      confirmReason(reas) {
        this.rejectTakeOrder(this.orderInfo.orderNo, reas)
        this.refuseShow = false
      },
      //去订单详情
      toOrderDetail() {
        this.$router.push({
          path: '/manage/orderdelivery/orderDetail',
          query: {
            id: this.orderInfo.orderNo,
          },
        })
      },
    },
  })
</script>

<style lang="scss" module>
  .order-box {
    width: 100%;
    height: 100px;
    margin-bottom: 15px;
    display: flex;
    .order-img {
      width: 100px;
      height: 100px;
      background: #f8f8f8;
      border-radius: 8px;
      margin-right: 12px;
    }
    .order-info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 100%;
      .order-name {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
      }
      .order-num {
        font-size: 12px;
        font-weight: 400;
        color: #999999;
        margin-top: 10px;
      }
      .order-space {
        font-size: 18px;
        font-weight: 500;
        color: #ff3b30;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        .space-icon {
          font-size: 12px;
        }
      }
    }
    .btn-style {
      height: 30px;
    }
    .take-orderbtn {
      margin-left: 12px;
    }
  }
</style>
